import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useStore } from '../../lib/store';
import { RefreshCwIcon, WalletIcon, StarIcon, GlobeIcon, HelpCircleIcon, ChevronRightIcon, LogOutIcon } from 'lucide-react';
interface AccountMenuListProps {
  onLanguageClick?: () => void;
}
export function AccountMenuList({
  onLanguageClick
}: AccountMenuListProps) {
  const navigate = useNavigate();
  const {
    language
  } = useStore();
  const menuItems = [{
    icon: RefreshCwIcon,
    label: 'Returns',
    path: '/account/returns',
    showArrow: true
  }, {
    icon: WalletIcon,
    label: 'My Wallet',
    path: '/account/wallet',
    showArrow: true
  }, {
    icon: StarIcon,
    label: 'Loyalty Points',
    path: '/account/points',
    showArrow: true
  }, {
    icon: GlobeIcon,
    label: `Language (${language === 'ar' ? 'Arabic' : 'English'})`,
    action: 'language',
    showArrow: true
  }, {
    icon: HelpCircleIcon,
    label: 'Help and Support',
    path: '/help-center',
    showArrow: true
  }];
  const handleItemClick = (item: any) => {
    if (item.action === 'language' && onLanguageClick) {
      onLanguageClick();
    } else if (item.path) {
      navigate(item.path);
    }
  };
  return <div className="bg-white" data-id="element-278" data-mp="3lpblb98ko7nj">
      {/* Menu Items */}
      <div className="px-4 py-2" data-id="element-279" data-mp="3lo0k9h6ihe04">
        {menuItems.map((item, index) => {
        const Icon = item.icon;
        return <button key={index} onClick={() => handleItemClick(item)} className="w-full flex items-center justify-between py-4 border-b border-gray-100 last:border-b-0 hover:bg-gray-50 transition-colors" data-id="element-280" data-mp="3bsgnyto1cdau" data-mpi={index}>
              <div className="flex items-center gap-3" data-id="element-281" data-mp="32td4vpovbxwc">
                <Icon className="w-5 h-5 text-gray-600" data-id="element-282" data-mp="w1ug46mvh7sr" />
                <span className="text-sm font-medium text-gray-900" data-id="element-283" data-mp="10zvy0o8kb12n">
                  {item.label}
                </span>
              </div>
              <div className="flex items-center gap-2" data-id="element-284" data-mp="yma99zopj1dy">
                {item.showArrow && <ChevronRightIcon className="w-5 h-5 text-gray-400" data-id="element-285" data-mp="uiko7k78r1xo" />}
              </div>
            </button>;
      })}
      </div>
      {/* Sign Out Button */}
      <div className="px-4 py-4 bg-red-50" data-id="element-286" data-mp="km9bit3qoa2p">
        <button onClick={() => {
        // Handle sign out
        console.log('Sign out');
      }} className="w-full flex items-center justify-center gap-2 py-3 text-red-600 font-semibold hover:text-red-700 transition-colors" data-id="element-287" data-mp="knapp6g1xcon">
          <LogOutIcon className="w-5 h-5" data-id="element-288" data-mp="18i3wqe3ysfai" />
          <span data-id="element-289" data-mp="18h2addhi06dh">Sign Out</span>
        </button>
      </div>
    </div>;
}